import React, {useEffect, useRef, useState} from "react";
import TrimbleMap from "../../map/TrimbleMap";

const ACTIVE_LOAD_TYPES = new Set(['IN_TRANSIT', 'PICKUP_IN_PROGRESS', 'DELIVERY_IN_PROGRESS']);
const PLANNED_LOAD_TYPES = new Set(['PICKUP_PLANNED', 'IN_TRANSIT_PLANNED', 'DELIVERY_PLANNED']);
const COMPLETED_LOAD_TYPES = new Set(['PICKED', 'DELIVERED', 'IN_TRANSIT_COMPLETED']);
const ALL_LOAD_TYPES = new Set([...ACTIVE_LOAD_TYPES, ...PLANNED_LOAD_TYPES, ...COMPLETED_LOAD_TYPES]);

function parseRouteData(driverData) {
    const schedule = driverData?.Schedule;
    if (!schedule) return {destinationMarker: null, availabilityMarker: null};

    const sortedDates = Object.keys(schedule).sort();

    let destinationMarker = null;
    let availabilityMarker = null;

    for (const date of sortedDates) {
        const entries = schedule[date] ?? [];
        for (const entry of entries) {
            const load = entry.Load;
            if (!load?.DestinationLatitude || !load?.DestinationLongitude) continue;

            const destLat = parseFloat(load.DestinationLatitude);
            const destLng = parseFloat(load.DestinationLongitude);
            if (!destLat || !destLng) continue;

            // Track the chronologically last load destination as the availability point
            if (ALL_LOAD_TYPES.has(entry.Type)) {
                availabilityMarker = {
                    Latitude: destLat,
                    Longitude: destLng,
                    label: entry.ShortLocation || 'Available'
                };
            }

            // First active or planned load is where the driver will end up (destination line)
            if (!destinationMarker && (ACTIVE_LOAD_TYPES.has(entry.Type) || PLANNED_LOAD_TYPES.has(entry.Type))) {
                destinationMarker = {
                    Latitude: destLat,
                    Longitude: destLng,
                    label: entry.ShortLocation || 'Destination'
                };
            }
        }
    }

    // If destination and availability are the same location, omit the duplicate availability marker
    if (
        destinationMarker && availabilityMarker &&
        Math.abs(destinationMarker.Latitude - availabilityMarker.Latitude) < 0.01 &&
        Math.abs(destinationMarker.Longitude - availabilityMarker.Longitude) < 0.01
    ) {
        availabilityMarker = null;
    }

    return {destinationMarker, availabilityMarker};
}

export default function FleetShareTableMap({selectedLocation, mapContainerID, translate}) {
    const mapRef = useRef();

    const [initializeMap, setInitializeMap] = useState(false)

    useEffect(() => {
        setTimeout(() => setInitializeMap(true), 300)
    }, []);

    const {destinationMarker, availabilityMarker} = parseRouteData(selectedLocation);

    return <div className="relative h-[calc(100vh-12rem)]">
        {initializeMap && (
            <TrimbleMap
                className={"absolute inset-0 h-full"}
                mapContainerID={mapContainerID}
                stops={[]}
                mapRef={mapRef}
                translate={translate}
                tracks={[selectedLocation]}
                destinationMarker={destinationMarker}
                availabilityMarker={availabilityMarker}
            />
        )}
    </div>
}